////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'
import Store from '../../helpers/Store'
import initialState from '../initialState'

extendUpdate(update)

const login = {
	[ActionsTypes.GET_LOGIN]: (state) =>
		update(state, {
			user: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_LOGIN_SUCCESS]: (state, payload) => {
		const user = payload.user
		Store.set('user', { jwttoken: user.jwttoken })
		user.kioskSelected = user.kiosksPool
		user.idPerimeter = 0

		return update(state, {
			user: {
				isLoading: {
					$set: false,
				},
				identity: {
					$set: { ...user },
				},
				isConnected: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.GET_LOGIN_FAILURE]: (state, payload) =>
		update(state, {
			user: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isConnected: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_CURRENT_USER]: (state) =>
		update(state, {
			user: {
				isLoading: {
					$set: true,
				},
			},
		}),

	[ActionsTypes.CHANGE_PATH_USER]: (state, payload) =>
		update(state, {
			user: {
				path: {
					$set: payload.path,
				},
			},
		}),
	[ActionsTypes.GET_LOGOUT]: (state) => {
		const initUser = cloneDeep(initialState.user)
		const initLanguages = cloneDeep(initialState.languages)
		Store.remove('user')

		return update(state, {
			user: {
				$set: { ...initUser, tableReferential: undefined },
			},
			languages: {
				$set: { ...initLanguages },
			},
			languages: {
				$set: { ...initLanguages },
			},
		})
	},

	[ActionsTypes.POST_FORGOT_LOGIN]: (state) =>
		update(state, {
			user: {
				forgotLogin: {
					status: {
						$set: 0,
					},
					isLoading: {
						$set: true,
					},
					error: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.POST_FORGOT_LOGIN_SUCCESS]: (state, payload) => {
		return update(state, {
			user: {
				forgotLogin: {
					status: {
						$set: payload.response,
					},
					isLoading: {
						$set: false,
					},
					error: {
						$set: false,
					},
				},
			},
		})
	},
	[ActionsTypes.POST_FORGOT_LOGIN_FAILURE]: (state, payload) =>
		update(state, {
			user: {
				forgotLogin: {
					status: {
						$set: payload.error.status,
					},
					isLoading: {
						$set: false,
					},
					error: {
						$set: payload.error,
					},
				},
			},
		}),

	[ActionsTypes.POST_FORGOT_LOGIN_RESET]: (state, _payload) =>
		update(state, {
			user: {
				forgotLogin: {
					status: {
						$set: 0,
					},
					isLoading: {
						$set: false,
					},
					error: {
						$set: false,
					},
				},
			},
		}),

	[ActionsTypes.POST_FORGOT_PASSWORD]: (state) =>
		update(state, {
			user: {
				forgotPassword: {
					status: {
						$set: 0,
					},
					isLoading: {
						$set: true,
					},
					error: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.POST_FORGOT_PASSWORD_SUCCESS]: (state, payload) => {
		return update(state, {
			user: {
				forgotPassword: {
					status: {
						$set: payload.response,
					},
					isLoading: {
						$set: false,
					},
					error: {
						$set: false,
					},
				},
			},
		})
	},
	[ActionsTypes.POST_FORGOT_PASSWORD_FAILURE]: (state, payload) =>
		update(state, {
			user: {
				forgotPassword: {
					status: {
						$set: payload.error.status,
					},
					isLoading: {
						$set: false,
					},
					error: {
						$set: payload.error,
					},
				},
			},
		}),

	[ActionsTypes.POST_FORGOT_PASSWORD_RESET]: (state, _payload) =>
		update(state, {
			user: {
				forgotPassword: {
					status: {
						$set: 0,
					},
					isLoading: {
						$set: false,
					},
					error: {
						$set: false,
					},
				},
			},
		}),
}

export default login
